import React from 'react'
import { useAuth } from '../hooks/useAuth'

function DebugAdminStatus() {
  const { user, isAuthenticated } = useAuth()
  
  return (
    <div className="fixed bottom-4 right-4 bg-gray-900 text-white p-4 rounded-lg shadow-lg text-xs max-w-sm">
      <h3 className="font-bold mb-2">Debug: Auth Status</h3>
      <div className="space-y-1">
        <div>Authenticated: {isAuthenticated ? 'Yes' : 'No'}</div>
        <div>Email: {user?.user?.email || 'N/A'}</div>
        <div>User ID: {user?.user?.id || 'N/A'}</div>
        <div>Profile ID: {user?.profile?.id || 'N/A'}</div>
        <div className="font-bold text-yellow-400">
          Is Admin: {user?.profile?.is_admin ? 'YES' : 'NO'}
        </div>
        <div>Plan: {user?.profile?.plan || 'N/A'}</div>
        <details className="mt-2">
          <summary className="cursor-pointer">Full User Object</summary>
          <pre className="mt-1 text-xs overflow-auto max-h-40">
            {JSON.stringify(user, null, 2)}
          </pre>
        </details>
      </div>
    </div>
  )
}

export default DebugAdminStatus